export default __webpack_public_path__ + "static/media/element_2.c2af9724.jpg";